import { Tabs } from "src/components/ui/tabs";
import { ReferenceBox } from "src/components/references/ReferenceBox";
import { components } from "src/strapi/schema";

export const ReferencesGrid = ({
  references,
}: {
  references: components["schemas"]["Reference"][];
}) => {
  return (
    <Tabs className={"w-full"}>
      <div className={"mt-8 grid w-full grid-cols-1 gap-4 lg:grid-cols-2"}>
        {references.map((reference) => {
          return (
            <ReferenceBox
              className={"h-[300px] w-full md:h-80 lg:h-[330px] xl:h-[350px]"}
              key={reference.id}
              reference={reference}
            />
          );
        })}
      </div>
    </Tabs>
  );
};
